import React from 'react';

import { routes } from 'navigation/routing';
import { t, tRich } from 'state/intl/translations';

import { OptInLabel, TermsLink } from '../styled';

import { RewardsPolicyTermsLink } from './rewards-policy-terms-link';

export const PromotionalEmailsLabel = () => {
  return (
    <OptInLabel testID={`opt-in-label-acceptEmailsAndSpecialOffers`}>
      {t('acceptEmailsAndSpecialOffers')}
    </OptInLabel>
  );
};

export const TermsOfServiceLabel = () => {
  const privacyPolicyLink = <TermsLink to={routes.privacyPolicy}>{t('privacyPolicy')}</TermsLink>;

  const rewardsPolicyLink = <RewardsPolicyTermsLink />;

  const termsOfServiceLink = (
    <TermsLink to={routes.termsOfService}>{t('termsOfService')}</TermsLink>
  );

  return (
    <OptInLabel>
      {tRich('acceptTermsAndPrivacyIntro', {
        termsOfServiceLink,
        privacyPolicyLink,
        rewardsPolicyLink,
      })}
    </OptInLabel>
  );
};
